// extracted by mini-css-extract-plugin
export default {"container":"ErrorLoadingRelatedTrainingClasses-module__container"};